module.exports = __webpack_public_path__ + "img/15.87a9ac3c.png";